import React, { useEffect, useState } from 'react';
import { message, Table, Tag, Input, Button, Form } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import * as dayjs from 'dayjs';

import { PAGE_SIZE } from '../../../common/consts';
import { FormsService } from '../../../API/FormsService';

import styles from './AllForms.module.css';

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: 'Имя',
        dataIndex: 'name',
        key: 'name',
    },

    {
        title: 'Ответы',
        dataIndex: 'allow',
        key: 'allow',
        width: 132,
        render: (_, { allow }) => {
            const isAllow = allow ? { color: 'green', text: 'Принимаются' } : { color: 'red', text: 'Не принимаются' };
            return <Tag color={isAllow.color}>{isAllow.text}</Tag>;
        },
    },
    {
        title: 'Создал запись',
        dataIndex: 'createdBy',
        key: 'createdBy',
    },
    {
        title: 'Дата создания',
        dataIndex: 'createdDate',
        key: 'createdDate',
        render: record => {
            return record && dayjs(record).format('DD.MM.YYYY HH:mm');
        },
    },
    { title: 'Изменил запись', dataIndex: 'modifiedBy', key: 'modifiedBy' },
    {
        title: 'Дата изменения',
        dataIndex: 'modifiedDate',
        key: 'modifiedDate',
        render: record => {
            return record && dayjs(record).format('DD.MM.YYYY HH:mm');
        },
    },
    { title: 'Кол-во ответов', dataIndex: 'resultsCount', key: 'resultsCount', width: '74px' },
    {
        dataIndex: 'delete',
        key: 'x',
        width: '64px',
    },
];

const AllForms = ({ user }) => {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrenPage] = useState(1);
    const [formIdValue, setFormIdValue] = useState('');
    const [formNameValue, setFormNameValue] = useState('');
    const [formAuthorValue, setFormAuthorValue] = useState('');

    let userEmail = formAuthorValue.length > 0 ? formAuthorValue : '';

    useEffect(() => {
        getData({ userEmail: user.username, currentPage });
    }, []);

    useEffect(() => {
        if (columns) {
            columns.forEach(el => {
                if (el.key === 'x') {
                    el.render = (_, { id, resultsCount }) => {
                        return resultsCount > 0 ? null : <DeleteOutlined onClick={() => handleDelete(id)} key={el.key} />;
                    };
                }
            });
        }
    }, [data]);

    const getData = async ({ userEmail, formName, formId, currentPage, pageSize = PAGE_SIZE }) => {
        setIsLoading(true);

        const { data } = await FormsService.getForms({ userEmail, formName, formId, page: currentPage, pageSize }, setIsLoading);
        setData(data.data);
        setTotal(data.totalCount);
        setIsLoading(false);
    };

    const handleDelete = async id => {
        try {
            const data = await FormsService.deleteForm(id, setIsLoading);

            if (data && data.status === 200) {
                getData({ userEmail: user.username, formName: formNameValue, formId: formIdValue, currentPage });
            }
        } catch (error) {
            setIsLoading(false);
            message.error(`Что-то пошло не так ${error?.message}`);
        }
    };

    const onSearch = event => {
        switch (event.target.name) {
            case 'formId':
                setFormIdValue(event.target.value);
                break;
            case 'formName':
                setFormNameValue(event.target.value);
                break;
            case 'formAuthor':
                setFormAuthorValue(event.target.value);
                break;
            default:
                break;
        }
    };

    const handleClick = () => {
        if (formAuthorValue.length <= 0 && formIdValue.length <= 0 && formNameValue.length <= 0) {
            userEmail = user.username;
        }
        
        getData({ userEmail: userEmail, formName: formNameValue, formId: formIdValue });
    };

    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 12,
                }}
                layout='horizontal'
                size='small'
            >
                <Form.Item label='ID формы'>
                    <Input placeholder='ID формы' onChange={onSearch} value={formIdValue} name='formId' />
                </Form.Item>
                <Form.Item label='Имя формы'>
                    <Input placeholder='Имя формы' onChange={onSearch} value={formNameValue} name='formName' />
                </Form.Item>
                <Form.Item label='Создатель формы (Email)'>
                    <Input placeholder='Создатель формы (Email)' onChange={onSearch} value={formAuthorValue} name='formAuthor' />
                </Form.Item>
                <Form.Item className={styles.buttonContainer}>
                    <Button type='primary' onClick={handleClick}>
                        Найти
                    </Button>
                </Form.Item>
            </Form>
            <Table
                columns={columns}
                dataSource={data}
                bordered
                size='small'
                scroll={{
                    y: 262,
                }}
                loading={isLoading}
                pagination={{
                    onChange: page => {
                        setCurrenPage(page);
                        getData({ userEmail: userEmail, formName: formNameValue, formId: formIdValue, currentPage: page });
                    },
                    pageSize: PAGE_SIZE,
                    current: currentPage,
                    total: total,
                }}
            />
        </>
    );
};

export default AllForms;
